"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from "react";
import { useLayout } from "../layout/LayoutContext";
import { useWave } from "@/hooks/useWave";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveTabsMeme from "./MyStreamWaveTabsMeme";
import MyStreamWaveTabsDefault from "./MyStreamWaveTabsDefault";
import useDeviceInfo from "../../../../hooks/useDeviceInfo";
import type { WaveViewMode } from "@/hooks/useWaveViewMode";
interface MyStreamWaveTabsProps {
  readonly wave: ApiWave;
  readonly viewMode: WaveViewMode;
  readonly onToggleViewMode: () => void;
  readonly showGalleryToggle: boolean;
  readonly activeCurationId: string | null;
  readonly onSelectCuration: (curationId: string | null) => void;
}
export const MyStreamWaveTabs: React.FC<MyStreamWaveTabsProps> = t0 => {
  const $ = _c(17);
  const {
    wave,
    viewMode,
    onToggleViewMode,
    showGalleryToggle,
    activeCurationId,
    onSelectCuration
  } = t0;
  const {
    isMemesWave
  } = useWave(wave);
  const {
    registerRef
  } = useLayout();
  const {
    isApp
  } = useDeviceInfo();
  const tabsElementRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isApp || $[1] !== registerRef) {
    t1 = () => {
      if (isApp) {
        registerRef("tabs", null);
      }
    };
    t2 = [isApp, registerRef];
    $[0] = isApp;
    $[1] = registerRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== registerRef) {
    t3 = element => {
      tabsElementRef.current = element;
      registerRef("tabs", element);
    };
    $[4] = registerRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const setTabsRef = t3;
  if (isApp) {
    return null;
  }
  let t4;
  if ($[6] !== activeCurationId || $[7] !== isMemesWave || $[8] !== onSelectCuration || $[9] !== onToggleViewMode || $[10] !== showGalleryToggle || $[11] !== viewMode || $[12] !== wave) {
    t4 = <div className="tw-w-full tw-bg-iron-950"><div className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-x-3">{isMemesWave ? <MyStreamWaveTabsMeme wave={wave} activeCurationId={activeCurationId} onSelectCuration={onSelectCuration} /> : <MyStreamWaveTabsDefault wave={wave} viewMode={viewMode} onToggleViewMode={onToggleViewMode} showGalleryToggle={showGalleryToggle} activeCurationId={activeCurationId} onSelectCuration={onSelectCuration} />}</div></div>;
    $[6] = activeCurationId;
    $[7] = isMemesWave;
    $[8] = onSelectCuration;
    $[9] = onToggleViewMode;
    $[10] = showGalleryToggle;
    $[11] = viewMode;
    $[12] = wave;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== setTabsRef || $[15] !== t4) {
    t5 = <div className="tw-flex-shrink-0" ref={setTabsRef} id="tabs-container">{t4}</div>;
    $[14] = setTabsRef;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};